module.exports = __webpack_public_path__ + "static/media/avast-vince-bungee.118fdb1b.jpg";